var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M868 242L868 270",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 868.5,
    cy: 237.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M863.987 237.19C863.987 233.283 867.288 230.117 871.358 230.117C871.943 230.117 872.511 230.184 873.056 230.308C871.742 229.48 870.187 229 868.519 229C863.814 229 860 232.806 860 237.5C860 242.194 863.814 246 868.519 246C870.814 246 872.895 245.093 874.427 243.62C873.492 244.032 872.454 244.263 871.358 244.263C867.288 244.263 863.987 241.096 863.987 237.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M877.402 236.6L877.37 234.146L875.535 235.719L873.304 235.056L874.112 237.337L872.765 239.381L875.1 239.218L876.499 241.144L877.133 238.763L879.345 237.909L877.402 236.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.652c43b6461e1b447d963146f9a4bc1b.svg";
export { ForwardRef as ReactComponent };